export default function accessDeep(obj, key) {
  if (!key) return;
  const deepKey = typeof key === 'string' ? key.split('.') : key;

  return deepKey.reduce((acc, cur) => acc && acc[cur], obj);
}
